import forgotPasswordComponent from './forgot_password.component';

let forgotPasswordModule = angular.module('forgotPassword', [
  ])

  .config(($stateProvider, $urlRouterProvider) => {
    "ngInject";

    $urlRouterProvider.otherwise('/forgor-password');

    $stateProvider
      .state('forgot_password', {
        url: '/forgot-password',
        component: 'forgotPassword',
        data: {
          requireLogin: false
        }
      })
      .state('change_password', {
        url: '/change-password',
        component: 'forgotPassword',
        params: {
          isForceChangedPassword: false
        },
        data: {
          requireLogin: false
        }
      });
  })

  .component('forgotPassword', forgotPasswordComponent)

  .name;

export default forgotPasswordModule;



// WEBPACK FOOTER //
// ./client/app/components/forgot_password/index.js